export default {
    bindings: {
        'inline': '<',
        'dateTime': '<'
    },
    controller: 'expiresAtController',
    template: require('../views/expiresAt.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/components/expiresAt.component.js